import { get,post } from '../request.js';

/**
 * 获取通知数据
 */
export async function noticePage(params) {
    return get('/api/notice/page', params);
}
/**
 * 获取数据数量
 */
 export async function noticeSumByType(params) {
    return get('/api/notice/sum_by_type', params);
}
/**
 * 标记已读
 */
 export async function noticeSetRead(params) {
    return post('/api/notice/set_read', params);
}
/**
 * 全部已读
 */
 export async function noticeAllSetRead(params) {
    return post('/api/notice/all_set_read', params);
}